<template>
  <div class="webs-page row">
    <div class="left-wrap">
      <header-sources :header-title="$t('SOURCES.HEADER')" />
      <web-table
        :webs="webList"
        :is-loading="uiFlags.isFetching"
        @show-add-web="onOpenAddWeb"
        @on-delete-click="openDeletePopup"
      />
      <table-footer
        :current-page="Number(meta.currentPage)"
        :total-count="meta.totalEntries"
        :page-size="meta.perPage"
        @page-change="onPageChange"
      />
    </div>
    <woot-modal :show.sync="showAddWeb" :on-close="onHideAddWeb">
      <create-scrape-website
        :current-web="currentWeb"
        :header-title="modalHeaderTitle"
        @close="onHideAddWeb"
      />
    </woot-modal>
    <woot-delete-modal
      :show.sync="showDeletePopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.TITLE')"
      :message="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.MESSAGE')"
      :message-value="currentWeb ? currentWeb.title + '?' : ''"
      :confirm-text="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.YES')"
      :reject-text="$t('WEB_SOURCES.ACTIONS.DELETE.CONFIRM.NO')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import CreateScrapeWebsite from './components/CreateScrapeWebsite.vue';
import HeaderSources from './components/Header.vue';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import WebTable from './components/WebTable.vue';
const DEFAULT_PAGE = 1;

export default {
  name: 'WebsSources',
  components: {
    CreateScrapeWebsite,
    HeaderSources,
    TableFooter,
    WebTable,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      loading: {},
      showAddWeb: false,
      currentWeb: {},
      showDeletePopup: false,
      modalHeaderTitle: this.$t('WEB_SOURCES.SCRAPE_SOURCE.TITLE'),
    };
  },
  computed: {
    ...mapGetters({
      webList: 'webs/getWebs',
      uiFlags: 'webs/getUIFlags',
      meta: 'webs/getMeta',
    }),
    pageParameter() {
      const selectedPageNumber = Number(this.$route.query?.page);
      return !Number.isNaN(selectedPageNumber) &&
        selectedPageNumber >= DEFAULT_PAGE
        ? selectedPageNumber
        : DEFAULT_PAGE;
    },
  },
  mounted() {
    this.fetchWebs(this.pageParameter);
  },
  methods: {
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    fetchWebs(page) {
      this.updatePageParam(page);
      const requestParams = {
        page,
        perPage: this.meta.perPage,
        sortBy: this.meta.sortBy,
        sortOrder: this.meta.sortOrder,
      };
      this.$store.dispatch('webs/get', requestParams);
    },
    onRefreshClick() {
      this.fetchWebs(this.meta.currentPage);
    },
    onPageChange(page) {
      this.fetchWebs(page);
    },
    onOpenAddWeb() {
      this.showAddWeb = true;
    },
    onHideAddWeb() {
      this.modalHeaderTitle = this.$t('WEB_SOURCES.SCRAPE_SOURCE.TITLE');
      this.currentWeb = {};
      this.showAddWeb = false;
    },
    openDeletePopup(web) {
      this.currentWeb = web;
      this.showDeletePopup = true;
    },
    closeDeletePopup() {
      this.currentWeb = {};
      this.showDeletePopup = false;
    },
    async confirmDeletion() {
      this.loading[this.currentWeb.id] = true;
      await this.deleteWeb(this.currentWeb);
      this.closeDeletePopup();
    },
    async deleteWeb(web) {
      try {
        await this.$store.dispatch('webs/delete', { id: web.id });
        this.showAlert(
          this.$t('WEB_SOURCES.ACTIONS.DELETE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        this.showAlert(this.$t('WEB_SOURCES.ACTIONS.DELETE.API.ERROR_MESSAGE'));
      }
    },
    // Show SnackBar
    showAlert(message) {
      // Reset loading, current selected agent
      this.loading[this.currentWeb.id] = false;
      this.currentWeb = {};
      // Show message
      bus.$emit('newToastMessage', message);
    },
  },
};
</script>

<style scoped lang="scss">
.webs-page {
  width: 100%;
  background: var(--s-25);
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
}
.footer {
  margin-top: auto;
  background: var(--white);
}
</style>
